import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function baseDate(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@baseDate/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@baseDate/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@baseDate/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@baseDate/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@baseDate/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@baseDate/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}
